export class Global {

    public static detectTransEndType() {
        let t: any;
        let el: HTMLElement = document.createElement('fakeelement');
        let transitions: any = {
            'transition': 'transitionend',
            'OTransition': 'oTransitionEnd',
            'MozTransition': 'transitionend',
            'WebkitTransition': 'webkitTransitionEnd'
        };

        for (t in transitions) {
            if (transitions.hasOwnProperty(t) && el.style[t] !== undefined) {
                return transitions[t];
            }
        }
    }

    public static newTag(tg: string, cn?: string) {
        let elem = document.createElement(tg);
        if (typeof cn != 'undefined') elem.className = cn;
        return elem;
    }

    public static getViewport() {
        var e: any = window;
        var a: string = 'inner';
        if (!('innerWidth' in window)) {
            a = 'client';
            e = document.documentElement || document.body;
        }
        return {width: e[a + 'Width'], height: e[a + 'Height']};
    }

    public static getHash = (link: HTMLAnchorElement) => {
        if (link.hash !== "") {
            return link.hash;
        } else {
            let href = String($(link).attr('href'));
            if (-1 != href.indexOf('#')) {
                return href.split('#').pop();
            }
        }
        return false;
    }

    /* Getters / Setters
    */

    public static get detectTransitionEvent(): string {
        return Global.detectTransEndType();
    }


}